/* ==================== ADS – H5 Games Ads-wrapper =============================
   Eneste modul der taler med Ad Placement API'et (adBreak/adConfig via
   adsbygoogle-push, bootstrap i index.html). Spilkoden kalder ALDRIG adBreak
   direkte — den går gennem rewards.js, som går gennem showRewardedAd her.

   Policy-regler (overtrædelse = AdSense-ban, roadmap 1.4):
   - Belønning gives KUN ved adViewed — aldrig ved dismissed/timeout/error.
   - Al spillyd mutes mens annoncen vises (audio.js-gaten).
   - Ingen live ads under udvikling: på localhost (eller med
     localStorage carnival.adtest) simuleres annoncen med et overlay,
     så hele reward-flowet kan testes uden Google.

   Før H5-godkendelsen lander, fyrer adConfig's onReady aldrig i prod →
   adsAvailable() er false → ingen tilbud vises. Koden kan altså deployes
   sikkert, mens ansøgningen behandles.
================================================================================ */

import { muteAll, unmuteAll } from "./audio.js";

const TEST =
  typeof location !== "undefined" &&
  (location.hostname === "localhost" ||
    location.hostname === "127.0.0.1" ||
    !!localStorage.getItem("carnival.adtest"));

let adsReady = false;
let initDone = false;
let showing = false;

const push = (o) => {
  (window.adsbygoogle = window.adsbygoogle || []).push(o);
};

/** Kaldes én gang ved app-start (main.jsx). */
export function initAds() {
  if (initDone) return;
  initDone = true;
  if (TEST) { adsReady = true; return; }
  try {
    push({
      preloadAdBreaks: "on",
      sound: "on", // spillet HAR lyd — skal angives
      onReady: () => { adsReady = true; },
    });
  } catch (e) { /* ad-script blokeret/utilgængeligt → ingen tilbud */ }
}

/** Må vi overhovedet tilbyde en video lige nu? */
export function adsAvailable() {
  return adsReady && !showing;
}

/**
 * Rewarded video. onReward kaldes KUN ved fuldt set annonce;
 * alle andre udfald ender i onNoReward(reason).
 */
export function showRewardedAd({ name, onReward, onNoReward }) {
  if (!adsAvailable()) { onNoReward && onNoReward("unavailable"); return; }
  showing = true;
  const finish = (rewarded, reason) => {
    if (!showing) return;
    showing = false;
    unmuteAll();
    if (rewarded) onReward && onReward();
    else onNoReward && onNoReward(reason);
  };

  if (TEST) { fakeAdOverlay(finish); return; }

  let rewarded = false;
  push({
    type: "reward",
    name,
    beforeAd: () => muteAll(),
    afterAd: () => unmuteAll(),
    beforeReward: (showAdFn) => { showAdFn(); },
    adDismissed: () => { rewarded = false; },
    adViewed: () => { rewarded = true; },
    adBreakDone: (info) => {
      // adBreakDone kommer ALTID (også uden fill) — konkludér her
      finish(rewarded && info && info.breakStatus === "viewed", (info && info.breakStatus) || "error");
    },
  });
}

/* ---- fake annonce til test-mode: 3 sek. nedtælling → reward; luk = ingen.
   Dev-only DOM-overlay (vises aldrig i prod), derfor hardcodede tekster. ---- */
function fakeAdOverlay(finish) {
  muteAll();
  const el = document.createElement("div");
  el.style.cssText =
    "position:fixed;inset:0;z-index:9999;background:#111;color:#fff;display:flex;flex-direction:column;" +
    "align-items:center;justify-content:center;gap:18px;font:800 18px system-ui,sans-serif;text-align:center;";
  el.innerHTML =
    '<div style="font-size:13px;letter-spacing:2px;opacity:.6">TEST-ANNONCE (localhost)</div>' +
    '<div style="font-size:34px;letter-spacing:4px">AD</div>' +
    '<div data-cnt style="font-size:22px">3</div>' +
    '<button data-x style="position:absolute;top:14px;right:14px;background:#333;color:#fff;border:none;' +
    'border-radius:50%;width:36px;height:36px;font-size:18px;cursor:pointer">✕</button>';
  document.body.appendChild(el);
  const done = (rewarded, reason) => { clearInterval(iv); el.remove(); finish(rewarded, reason); };
  let n = 3;
  const iv = setInterval(() => {
    n -= 1;
    const c = el.querySelector("[data-cnt]");
    if (c) c.textContent = String(Math.max(0, n));
    if (n <= 0) done(true, "viewed");
  }, 1000);
  el.querySelector("[data-x]").addEventListener("click", () => done(false, "dismissed"));
}
